import PriceBreakdownSFC from "./PriceBreakdown.vue";
export const PriceBreakdown = PriceBreakdownSFC;
